import React from 'react'
import * as styles from './index.module.less'
import useIsWindowWidthSmaller from 'hooks/useWindowWidth'

import abtest from './img/abtest.png'
import scfx from './img/scfx.png'
import scggfx from './img/scggfx.png'
import scsjpt from './img/scsjpt.png'
import scznyy from './img/scznyy.png'

interface ProductCardProps {
  list?: string[]
  lang?: 'zh' | 'en'
}

const cardMap = {
  scsjpt: {
    title: '神策数界平台',
    enTitle: 'Sensors Data Horizon',
    icon: scsjpt,
    desc: '企业级客户数据平台（CDP），解决数据孤岛问题，建立统一的用户、客户、产品档案，帮助企业实现数字化转型。',
    enDesc:
      'The Enterprise Customer Data Platform (CDP) focuses on eliminating data silos, unifying customer and product profiles, and empowering companies to drive customer operations with data.',
    linkText: '了解更多',
    linkTextEn: 'Learn More',
    link: 'https://www.sensorsdata.cn/product/cdp.html',
    linkEn: 'https://www.sensorsdata.com/product/cdp/',
  },
  scfx: {
    title: '神策分析',
    enTitle: 'Sensors Analytics',
    icon: scfx,
    desc: '实现从用户到经营的全链路、全场景分析，提供全面有效的市场信息和经营策略，帮助企业更好地了解用户、掌握市场、提高竞争力。',
    enDesc:
      'The Analytics Platform empowers deeper customer understanding for better business decisions with its full-link, full-scenario analysis and strategic market insights.',
    linkText: '了解更多',
    linkTextEn: 'Learn More',
    link: 'https://www.sensorsdata.cn/product/analysis.html',
    linkEn: 'https://www.sensorsdata.com/product/analysis/',
  },
  scznyy: {
    title: '神策智能运营',
    enTitle: 'Sensors Focus',
    icon: scznyy,
    desc: '打通全域数据、连接全场景的自动化营销平台，实现自动、实时、智能的全场景营销闭环，提升关键指标和运营效率。',
    enDesc:
      'The Marketing Automation Platform that integrates data from all channels, achieving an automated, real-time, and intelligent full-scenario marketing loop, and improving key indicators and operational efficiency.',
    linkText: '了解更多',
    linkTextEn: 'Learn More',
    link: 'https://www.sensorsdata.cn/product/focus.html',
    linkEn: 'https://www.sensorsdata.com/product/focus',
  },
  scggfx: {
    title: '神策广告分析',
    enTitle: 'Sensors Advertising Tracking',
    icon: scggfx,
    desc: '全域深链路广告投放分析系统，结合多维度报表及分析模型，满足用户洞察、广告渠道归因分析、品牌资产沉淀的需求。',
    enDesc:
      'The Analytics Platform empowers deeper customer understanding for better business decisions with its full-link, full-scenario analysis and strategic market insights.',
    linkText: '了解更多',
    linkTextEn: 'Learn More',
    link: 'https://www.sensorsdata.cn/product/ad.html',
  },
  abtest: {
    title: '神策 A/B 测试',
    enTitle: 'Sensors A/B Testing',
    icon: abtest,
    desc: '在分析业务全流程的基础上，有效降低行动成本与风险，帮助产品、运营与营销人员通过测试择优选取策略，实现业绩增长。',
    enDesc:
      'The Analytics Platform empowers deeper customer understanding for better business decisions with its full-link, full-scenario analysis and strategic market insights.',
    linkText: '了解更多',
    linkTextEn: 'Learn More',
    link: 'https://www.sensorsdata.cn/features/ABTesting.html',
  },
}

const ProductCard: React.FC<ProductCardProps> = (props) => {
  const { lang = 'zh', list = ['scsjpt', 'scfx', 'scznyy', 'scggfx', 'abtest'] } = props
  const firstLineNum = list.length % 3
  const isMb = useIsWindowWidthSmaller()
  const handleClickLink = (url) => {
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('target', '__blank')
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
  const ItemCom = (item) => {
    return (
      <div
        className={styles.cardItem}
        onClick={() => {
          handleClickLink(lang === 'zh' ? item.link : item.linkEn ?? item.link)
        }}
      >
        <div className={styles.head}>
          <img className={styles.icon} src={item.icon} alt={item.title} />
          <div className={styles.titles}>
            <div className={styles.zhTitle}>{lang === 'zh' ? item.title : item.enTitle}</div>
            {lang === 'zh' && <div className={styles.enTitle}>{item.enTitle}</div>}
          </div>
        </div>
        <div className={styles.desc}>{lang === 'zh' ? item.desc : item.enDesc}</div>
        <div className={styles.linkText}>{lang === 'zh' ? item.linkText : item.linkTextEn}</div>
      </div>
    )
  }
  return isMb ? (
    <div className={styles.cardSwiperWrapperMb}>
      {list.map((item, index) => {
        return <ItemCom {...cardMap[item]} key={cardMap[item].desc} />
      })}
    </div>
  ) : (
    <div className={styles.cardSwiperWrapper}>
      <div className={styles.firstLine}>
        {list.map((item, index) => {
          if (index < firstLineNum) {
            return <ItemCom {...cardMap[item]} key={cardMap[item].desc} />
          }
        })}
      </div>
      <div className={styles.otherLine}>
        {list.map((item, index) => {
          if (index > firstLineNum - 1) {
            return <ItemCom {...cardMap[item]} key={cardMap[item].desc} />
          }
        })}
      </div>
    </div>
  )
}

export default ProductCard
